import { BUTTON_SIZES } from '@elliemae/ds-button-v2';
import { DatePicker } from '@elliemae/ds-icons';
import { useContext, useMemo } from 'react';
import { ControlledDateTimePickerDatatestid } from '../../../constants/index.js';
import { ControlledDateTimePickerContext } from '../../../ControlledDateTimePickerCTX.js';
import { CalendarContext } from './CalendarContext.js';
import { StyledIconTriggerButton } from './Styleds.js';
// we memoize the Icon  for maximum optimization
// this is particularly usefull due to how usePopper needs to check the references
// since references are saved in a immutable way, we make sure to shortcircuit useless-re-renders
export const CalendarIconTrigger = (): JSX.Element => {
  const { handleToggleCalendar, handleSetTriggerRef, handlePickerIconKeyDown } = useContext(CalendarContext);
  const {
    props: { disabled, tabIndex },
    getProps,
    ariaCurrentValueForInputs,
  } = useContext(ControlledDateTimePickerContext);
  return useMemo(
    () => (
      <StyledIconTriggerButton
        aria-label={`date picker context menu trigger, ${ariaCurrentValueForInputs}`}
        buttonType="icon"
        size={BUTTON_SIZES.M}
        innerRef={handleSetTriggerRef}
        tabIndex={tabIndex}
        onClick={handleToggleCalendar}
        onKeyDown={handlePickerIconKeyDown}
        data-testid={ControlledDateTimePickerDatatestid.PICKER_ICONS.CALENDAR}
        disabled={disabled}
        type="button"
        getOwnerProps={getProps}
      >
        <DatePicker color={disabled ? ['neutral', '500'] : ['brand-primary', '800']} />
      </StyledIconTriggerButton>
    ),
    [
      ariaCurrentValueForInputs,
      handleSetTriggerRef,
      tabIndex,
      handleToggleCalendar,
      handlePickerIconKeyDown,
      disabled,
      getProps,
    ],
  );
};
